module.exports = __webpack_public_path__ + "static/unionFlag-52f954a7ac2dfc201561f18d5a6931f2.svg";